<template>
    <div>
        <!--意见反馈dialog-->
        <el-dialog title="意见反馈"
                   :visible.sync="showIdeaDialog"
                   :lock-scroll="false"
                   :close-on-click-modal="false"
                   width="700px"
                   @closed="closeDialog">
            <el-form ref="ideaForm" :model="ideaForm" :rules="ideaFormRules">
                <el-divider></el-divider>
                <el-form-item prop="content">
                    <el-input type="textarea" v-model="ideaForm.content"
                              placeholder="请填写具体内容帮助我们了解您的意见与建议"
                              :rows="3"
                              maxlength="100"
                              show-word-limit></el-input>
                </el-form-item>
                <el-divider></el-divider>
                <el-upload :action="uploadUrl"
                       ref="upload"
                       list-type="picture-card"
                       multiple
                       :limit=2
                       :auto-upload="false"
                       :file-list="fileList"
                       :on-change="handleOnchange"
                       :on-exceed="handleExceed"
                       :on-success="uploadSuccess">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" >
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                              <i class="el-icon-zoom-in"></i>
                            </span>
                             <span class="el-upload-list__item-delete" @click="handleRemove(file)" >
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </div>
                    <div slot="tip" class="el-upload__tip">最多可以上传 2 张图片, 且图片大小不能超过 2M</div>
                </el-upload>
                <el-divider></el-divider>
                <el-form-item prop="contactInfo">
                    <el-input v-model="ideaForm.contactInfo"
                              placeholder="请留下真实联系方式( 如QQ、邮箱 ), 方便我们答疑解惑 !">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align: center">
                <el-button type="primary" @click="submitIdea">提交</el-button>
                <el-button @click="closeDialog">取 消</el-button>
            </div>
        </el-dialog>
        <!--图片预览dialog-->
        <el-dialog :visible.sync="showBigImageDialog">
            <img width="100%" :src="showBigImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "IdeaDialog",
        data() {
            return {
                showIdeaDialog: false,
                uploadUrl: '',
                fileList: [],
                uploadSuccessCount: 0,
                showBigImageUrl: '',
                showBigImageDialog: false,
                ideaForm: {
                    content: '',
                    imageUrls: [],
                    contactInfo: ''
                },
                ideaFormRules: {
                    content: [{ required: true, message: '意见反馈内容不能为空', trigger: 'blur' }],
                    contactInfo: [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],
                }
            }
        },
        methods: {
            showDialog() {
                this.showIdeaDialog = true;
            },
            handlePictureCardPreview(file) {
                this.showBigImageUrl = file.url;
                this.showBigImageDialog = true;
            },
            handleOnchange(file, fileList) {
                this.fileList = fileList;
            },
            handleExceed(file, fileList) {
                this.$message.error('最多只能上传2张图片 !');
            },
            handleRemove(file) {
                this.fileList = this.fileList.filter(item => item.uid !== file.uid);
            },
            submitIdea() {
                this.$refs.ideaForm.validate(async (valid) => {
                    if (valid) {
                        if (this.fileList.length > 0) {
                            this.uploadImgAndSubmit();
                        } else {
                            this.submit();
                        }
                    }
                });
            },
            uploadImgAndSubmit() {
                this.$refs.upload.submit();
            },
            // 图片每上传成功一次都会调
            uploadSuccess(response, file, fileList) {
                this.ideaForm.imageUrls.push(response.content);
                if (++this.uploadSuccessCount === this.fileList.length) {
                    this.submit();
                }
            },
            async submit() {
                const {success} = await this.$http.post("/business/web/idea/submitIdea", this.ideaForm);
                if (success) {
                    this.closeDialog();
                    this.$message.success('提交成功 !');
                }
            },
            closeDialog() {
                this.fileList = [];
                this.uploadSuccessCount = 0;
                this.$refs.ideaForm.resetFields();
                this.showIdeaDialog = false;
            }
        },
        created() {
            this.uploadUrl = process.env.VUE_APP_SERVER + '/file/web/uploadOss'
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-dialog__body  {
        padding: 0 30px;
    }

    .el-divider {
        margin: 15px 0;
    }
</style>
